<template>
  <div id="bar-stacked" class="echarts">
    <VueApexCharts 
      type="bar"
      :options="options"
      :series="series"
      height="100%"
    >
    </VueApexCharts>
  </div>
</template>

<script >
import VueApexCharts from 'vue-apexcharts'
import { sync } from 'vuex-pathify'
import ui from '@/../../coreui/helpers/ui'

export default {
  props: ['args'],
  components: {
    VueApexCharts,
  },
  computed: {
    dark: sync('misc/dark'),
    fullScreen: sync('fullScreen'),
    cUnit () {
      return this.args.unit == undefined ? '' : ' '+this.args.unit
    }
  },
  watch: {
    // dark: {
    //   immediate: true,
    //   handler(val, old) {
    //     let newOptions = Object.assign({}, this.options, {
    //       chart: {
    //       background: ui.theme(val).lighterbg,
    //       },
    //       // theme: {
    //       //   mode : val ? 'dark' : 'light',
    //       //   palette: val ? this.args.palette_dark  :
    //       //   this.args.palette_light ,  
    //       // }
    //     })
    //     this.options = newOptions
    //   }
    // },
  },
  data() {
    return {
    series: [{
      name: 'Marine Sprite',
      data: [44, 55, 41, 37, 22, 43, 21]
    }, {
      name: 'Striking Calf',
      data: [53, 32, 33, 52, 13, 43, 32]
    }, {
      name: 'Tank Picture',
      data: [12, 17, 11, 9, 15, 11, 20]
    }, {
      name: 'Bucket Slope',
      data: [9, 7, 5, 8, 6, 9, 4]
    }, {
      name: 'Reborn Kid',
      data: [25, 12, 19, 32, 25, 24, 10]
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: { show: false},
        background: this.args.flat ? ui.theme(this.dark).plainBackground : ui.theme(this.dark).lighterbg,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      title: {
        text: 'Fiction Books Sales'
      },
      xaxis: {
        categories: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
        labels: {
          formatter: function (val) {
            return val + "K"
          }
        }
      },
      yaxis: {
        title: {
          text: undefined
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + "K"
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    },
    
    }
  },
}
      
</script>

<style scoped>
/* div.apexcharts-canvas.apexcharts-theme-dark {
  background: '#424242' !important;
} */

svg.apexcharts-svg { background: '#424242' !important; }
  .echarts {
    width: 100%;
    height: 100%;
    /* margin-left: 10px; */
    /* width: 50%; */
    /* height: 90%;
    margin-right: 3px;
    padding-right: 5px; */
  }
</style>